import React from 'react'
import { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'

const VehiculoDetalleModal = ({
    show,
    onHide,
    vehiculo,
    loading,
    tipos = [],
    onUpdateTipo,
    mode = 'view',
    onSave,
    permisos = {}
}) => {
    if (!show) return null

    const [tipoVehiculoId, setTipoVehiculoId] = useState(vehiculo?.tipo_vehiculo?.id || '')

    useEffect(() => {
        setTipoVehiculoId(vehiculo?.tipo_vehiculo?.id || '')
    }, [vehiculo])

    const handleTipoChange = e => {
        const value = e.target.value
        setTipoVehiculoId(value)
        if (onUpdateTipo) onUpdateTipo(Number(value))
    }

    const handleSave = () => {
        if (onSave && vehiculo) {
            onSave(vehiculo.id, { tipo_vehiculo_id: Number(tipoVehiculoId) })
        }
    }

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {mode === 'create' ? 'Nuevo Vehículo' : mode === 'edit' ? 'Editar Vehículo' : 'Detalle Vehículo'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="d-flex justify-content-center p-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Cargando...</span>
                        </div>
                    </div>
                ) : (
                    <div>
                        {mode === 'create' || !vehiculo ? (
                            // Formulario para crear nuevo vehículo
                            <div>
                                <div className="mb-3">
                                    <label className="form-label">PPU</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Ingrese PPU del vehículo"
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Tipo de Vehículo</label>
                                    <select className="form-select">
                                        <option value="">Seleccione un tipo</option>
                                        {tipos.map(t => (
                                            <option key={t.id} value={t.id}>
                                                {t.tipo}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        ) : (
                            // Mostrar detalles del vehículo existente
                            <div>
                                <p>
                                    <strong>PPU:</strong> {vehiculo?.ppu || 'N/A'}
                                </p>
                                <p>
                                    <strong>Tipo:</strong> {vehiculo?.tipo_vehiculo?.tipo || 'N/A'}
                                </p>
                                <p>
                                    <strong>Usuario Movil:</strong> {vehiculo?.usuario_movil?.usuarioSpread || 'N/A'}
                                </p>
                                <p>
                                    <strong>Conductores asociados:</strong> {vehiculo?.usuarios_moviles_count || 0}
                                </p>

                                {mode === 'edit' && permisos.canEdit && (
                                    <div className="mt-3">
                                        <label className="form-label">Tipo de Vehículo</label>
                                        <select
                                            className="form-select"
                                            value={tipoVehiculoId}
                                            onChange={handleTipoChange}>
                                            <option value="">Seleccione</option>
                                            {tipos.map(t => (
                                                <option key={t.id} value={t.id}>
                                                    {t.tipo}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
                {mode === 'create' && permisos.canCreate && (
                    <Button variant="primary" onClick={() => onSave && onSave()} disabled={loading}>
                        Crear Vehículo
                    </Button>
                )}
                {mode === 'edit' && permisos.canEdit && (
                    <Button variant="primary" onClick={handleSave} disabled={loading}>
                        Guardar Cambios
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    )
}

export default VehiculoDetalleModal
